export default __webpack_public_path__ + "static/media/AnimalsGreen_05.e1501291.png";